import { Input as AntInput, type GetProps } from 'antd';
import styled from 'styled-components';

type OTPProps = GetProps<typeof AntInput.OTP>;

export const StyledOTPInput = styled(AntInput.OTP)<OTPProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;

  .ant-otp-input {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.color.grey.grey5};
    box-shadow: none;
    font-size: 16px;
    text-align: center;

    &:hover {
      border-color: ${({ theme }) => theme.color.grey.grey9};
    }

    &:focus,
    &:focus-within {
      border-color: ${({ theme }) => theme.color.theme.primary};
      box-shadow: 0 0 0 2px ${({ theme }) => theme.color.theme.primary}33;
      outline: none;
    }
  }

  .ant-otp-input.ant-input-status-error,
  .ant-otp-input:has(.ant-input-status-error) {
    border-color: ${({ theme }) => theme.color.status.error};

    &:focus,
    &:focus-within {
      border-color: ${({ theme }) => theme.color.status.error};
      box-shadow: 0 0 0 2px ${({ theme }) => theme.color.status.error}33;
    }
  }
`;
